module.exports = __webpack_public_path__ + "static/16-36ae3e70553b975bc7a386c7ca556987.jpeg";